import moment from 'moment'
import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './routes/router'
import store from './stores/store'

Vue.config.productionTip = false

/* Application cookies */

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
/* Translation with i18n */

import i18n from '@/locales/config.js'

/* Global event Hub */

Vue.prototype.$eventHub = new Vue()

/* Application bootstrap */

new Vue({
    router,
    store,
    vuetify,
    i18n,
    moment,
    render: h => h(App)
}).$mount('#app')
